export function getCurrentYear() {
  const d = new Date();
  return d.getFullYear();
}

export const getNightWordByQuantity = (nights) => {
  let result;

  if (nights === 1) {
    result = 'ночь';
  } else if (nights <= 4) {
    result = 'ночи';
  } else {
    result = 'ночей';
  }

  return result;
};

export const getDayWordByQuantity = (days) => {
  const lastTwo = days % 100;
  const last = days % 10;
  let result;

  if (lastTwo >= 11 && lastTwo <= 14) {
    result = 'дней';
  } else if (last === 1) {
    result = 'день';
  } else if (last >= 2 && last <= 4) {
    result = 'дня';
  } else {
    result = 'дней';
  }

  return result;
};

export const getMealFullName = (code) => {
  let result = '';

  if (code === 'FB') {
    result = 'Завтрак, обед, ужин';
  } else if (code === 'HB') {
    result = 'Завтрак, ужин';
  } else if (code === 'BB') {
    result = 'Завтрак';
  } else if (code === 'AI') {
    result = 'Всё включено';
  } else if (code === 'UAI') {
    result = 'Всё включено ультра';
  } else if (code === 'RO') {
    result = 'Без питания';
  } else if (code === 'FB+') {
    result = 'Завтрак, обед, ужин ультра';
  } else if (code === 'HB+') {
    result = 'Завтрак, ужин ультра';
  } else if (code === 'SC') {
    result = 'Самообслуживание';
  }

  return result;
};

export const getAdultsDescription = (count) => {
  let result = '';

  if (count === 1) {
    result = 'взрослый';
  } else {
    result = 'взрослых';
  }

  return result;
};

export const getKidsDescription = (count) => {
  let result = '';

  if (count === 1) {
    result = 'ребенок';
  } else if (count <= 4) {
    result = 'ребенка';
  } else {
    result = 'детей';
  }

  return result;
};

export function getMonth(date) {
  let mounth;
  switch (date.getMonth()) {
    case 0:
      mounth = 'янв.';
      break;
    case 1:
      mounth = 'фев.';
      break;
    case 2:
      mounth = 'март';
      break;
    case 3:
      mounth = 'апр.';
      break;
    case 4:
      mounth = 'май';
      break;
    case 5:
      mounth = 'июн.';
      break;
    case 6:
      mounth = 'июл.';
      break;
    case 7:
      mounth = 'авг.';
      break;
    case 8:
      mounth = 'сен.';
      break;
    case 9:
      mounth = 'окт.';
      break;
    case 10:
      mounth = 'ноя.';
      break;
    case 11:
      mounth = 'дек.';
      break;

    default:
      break;
  }

  return mounth;
}

export function getDateText(date) {
  let result;

  if (date.from && date.to) {
    if (date.from.getMonth() === date.to.getMonth()) {
      if (date.from.getDate() === date.to.getDate()) {
        result = `${date.from.getDate()} ${getMonth(
          date.from,
        )} ${date.from.getFullYear()}`;
      } else {
        result = `${date.from.getDate()} - ${date.to.getDate()} ${getMonth(
          date.from,
        )} ${date.to.getFullYear()}`;
      }
    } else {
      result = `${date.from.getDate()} ${getMonth(
        date.from,
      )} - ${date.to.getDate()} ${getMonth(date.to)} ${date.to.getFullYear()}`;
    }
  } else if (date.from && !date.to) {
    result = `с ${date.from.getDate()} ${getMonth(date.from)}`;
  }

  return result;
}

export function getNightsText(nightsFrom, nightsTo) {
  if (nightsFrom && !nightsTo) {
    return `${nightsFrom} ночей`;
  }

  if (nightsFrom === nightsTo) {
    return `${nightsFrom} ночей`;
  }

  return `${nightsFrom} - ${nightsTo} ночей`;
}

export function formatSlashes(date) {
  return date.replace(/\//g, '-');
}
